<template>
    <b-container>
      <div class="home">  
        <b-row>
          <b-col lg="9" class="ml-2">
            <p class="h5 mb-4" v-html="$t('html.closed')"></p>
          </b-col>
        </b-row>
      </div>
      
      <div class="home" v-show="false">
          <b-container fluid>
              <div id="pgTitle" tabindex="-1"><h1>{{pageTitle}}</h1></div>
              <b-row v-if="showInfo">


                <div v-if="!interview.tokenStatus">
                  <b-col cols="12" class="mt-4">
                    <b-spinner variant="primary" label="Preparing interview."></b-spinner>
                    <span class="h5 ml-2" style="display: inline;">Preparing your interview...</span>
                  </b-col>
                </div>

                <div v-if="interview.tokenStatus === 'valid'">             
                  <b-col lg="9" class="ml-2">
                    <p class="h5 mb-4" v-html="$t('html.intro')"></p>
                    <b-button type='button' variant="primary" @click="startSurvey">{{$t('buttons.start')}}</b-button>
                  </b-col>
                </div>

                <div v-else>
                  <div v-if="interview.tokenStatus === 'missing'">
                    <b-col  class="ml-2 mt-4">
                      <b-alert show class="mb-4">
                        <p class="mt-2" v-html="$t('html.missingtoken')"></p>
                      </b-alert>
                    </b-col>
                  </div>

                  <div v-if="interview.tokenStatus === 'invalid'">
                    <b-col lg="12" class="ml-2 mt-4">
                      <b-alert show class="mb-4">
                          <p class="mt-2" v-html="$t('html.invalidtoken')"></p>
                      </b-alert>
                    </b-col>
                  </div>

                  <div v-if="interview.tokenStatus === 'expired'">
                    <b-col lg="12" class="ml-2 mt-4">
                      <b-alert show class="mb-4">
                          <p class="mt-2" v-html="$t('html.expiredtoken')"></p>
                      </b-alert>
                    </b-col>
                  </div>

                  <div v-if="interview.tokenStatus === 'used'">
                    <b-col lg="12" class="ml-2 mt-4">
                      <p class="h5 mb-4" v-html="$t('html.usedtoken')"></p>
                    </b-col>
                  </div>

                  <b-button type='button' variant="primary" v-if="interview.tokenStatus" class='ml-4' @click="showInfoPage">View COVID-19 Resources</b-button>
                </div>

              </b-row>
              
              <b-row v-else-if="!dataEntryComplete && !showInfo">
                  <b-col>                    
                      <form-wizard :stepSize="stepSize"
                          :nextButtonText="$t('buttons.next')"
                          :backButtonText="$t('buttons.back')"
                          :finishButtonText="$t('buttons.finish')"
                          color="#003865"
                          :layout="layout"
                          id="wizard"
                          @on-complete="onComplete"
                          @on-change="switchTabs">
                          <span slot="title" tabindex="-1"/>
                          <tab-content  :title="$t('breadcrumbs.language')" 
                              :before-change="()=>validateStep('lang')"
                              :after-change="()=>scrollTo()"
                              v-if="false">
                              <Language ref="lang" @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="$t('breadcrumbs.tennessen')" :before-change="()=>validateStep('twarn')"
                              :after-change="()=>scrollTo()">
                              <Tennessen ref="twarn" @on-validate="mergePartialModels" @showInfoPage="showInfoPage"/>
                          </tab-content> 

                          <tab-content :title="$t('breadcrumbs.person')" 
                              :before-change="()=>validateStep('person')"
                              :after-change="()=>scrollTo()">
                              <Person ref="person" :surveyAboutName=this.interview.firstName @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="$t('breadcrumbs.exposures')" 
                              :before-change="()=>validateStep('exp')"
                              :after-change="()=>scrollTo()">
                              <Exposure ref="exp" :symptoms=symptoms @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="$t('breadcrumbs.workplace')" 
                              :before-change="()=>validateStep('workplace')"
                              :after-change="()=>scrollTo()">
                              <Workplace ref="workplace" :symptoms=symptoms :email=email @on-validate="mergePartialModels"/>
                          </tab-content> 

                          <tab-content :title="$t('breadcrumbs.school')" 
                              :before-change="()=>validateStep('school')"
                              :after-change="()=>scrollTo()">
                              <Schools ref="school" :symptoms=symptoms :exclusionLetter=finalModel.requestExclusionLetter
                                :email=email @on-validate="mergePartialModels"/>
                          </tab-content> 

                          <tab-content :title="$t('breadcrumbs.essential')" 
                              :before-change="()=>validateStep('essential')"
                              :after-change="()=>scrollTo()">
                              <Essential ref="essential" :symptoms=symptoms @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="$t('breadcrumbs.contacts')"
                                      :before-change="()=>validateStep('contacts')"
                                      :after-change="()=>scrollTo()"
                                      v-if="false">
                            <Contacts ref="contacts" :symptoms=symptoms @on-validate="mergePartialModels"/>
                          </tab-content>

                        <tab-content :title="$t('breadcrumbs.covidAwareApp')"
                                     :before-change="()=>validateStep('covidAwareApp')"
                                     :after-change="()=>scrollTo()">
                          <CovidAwareApp ref="covidAwareApp" :symptoms=symptoms @on-validate="mergePartialModels"/>
                        </tab-content>
                      </form-wizard>
                  </b-col>
              </b-row>

              <b-container v-else>

                <b-row>
                  <b-col>
                    <h1 class="text-center" v-if="skipSurvey" v-html="$t('confirmPage.thanks')"></h1>
                    <h1 v-else class="text-center" v-html="$t('confirmPage.surveyThanks')"></h1>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p class="h5 mb-4" v-html="$t('confirmPage.confirmHeader')"></p>
                  </b-col>
                </b-row>               
                <b-row>
                  <b-col>
                    <p class="h5 mb-4 mt-4" v-html="$t('confirmPage.contactInfo')"></p>
                  </b-col>
                </b-row>
                
                <b-row>
                  <b-col>
                    <p class="" v-html="$t('confirmPage.disclaimer')"></p>
                  </b-col>
                </b-row>




                <div id="OldConfirmationBasedOnInterview" v-if="false">
                <b-card>
                  <b-card-header class="text-center">
                    <strong>{{$t('confirmPage.preventHeader')}}</strong>
                  </b-card-header>
                  <b-card-body>
                    <strong>{{$t('confirmPage.stayHome')}}</strong>
                    <p>{{$t('confirmPage.stayHomeDescript')}}</p>
                    <strong>{{$t('confirmPage.separate')}}</strong>
                    <p>{{$t('confirmPage.separateDescript')}}</p>
                    <strong>{{$t('confirmPage.monitor')}}</strong>
                    <p>{{$t('confirmPage.monitorDescript')}}</p>
                  </b-card-body>

                </b-card>
                <b-card>
                  <b-card-header class="text-center">
                    <strong>{{$t('confirmPage.contactHeader')}}</strong>
                  </b-card-header>
                  <b-card-body>
                    <p v-html="$t('confirmPage.contactBody')"></p>
                  </b-card-body>
                </b-card>
                </div>

              <div id="oldConfirmationPage" v-if="false">
              <b-row class="mt-5">
                  <b-col cols="12" lg="12"> 
                      <h2>Confirmation</h2>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="12" lg="6">
                      <h3 style="margin-top:25px;">Thank you for getting tested today.</h3>
                      <p style="font-size: 1.2em;"> If your test result is positive you will be contacted by public health for an interview.</p>
                      <div style="margin-top:45px; font-weight:700">
                          
                      <b-button id="btnHome" href="/" variant="primary">Return Home</b-button>
                          
                      </div>
                  </b-col>

                  <b-col cols="12" lg="6">
                      <qrcode-vue :value="shortCode" size="200" level="L"/><br/>
                      <span>{{shortCode}}</span>
                  </b-col>
                  </b-row>
              </div>
              </b-container>

          </b-container>
      </div>
    </b-container>

</template>

<script>
import LocalStorageService from '@/common/LocalStorageService';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import Language from '@/components/wizard/Language'
import Person from '@/components/wizard/Person'
import Contacts from '@/components/wizard/Contacts'
import Tennessen from '@/components/wizard/Tennessen'
import Workplace from '@/components/wizard/Workplace'
import Schools from '@/components/wizard/Schools'
import Exposure from '@/components/wizard/Exposure'
import Essential from '@/components/wizard/Essential'
import CovidAwareApp from '@/components/wizard/CovidAwareApp'
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'

export default {
  components: {
      Language,
      Person,
      Tennessen,
      Exposure,
      QrcodeVue,
      Contacts,
      Workplace,
      Schools,
      Essential,
      CovidAwareApp,
  },
  
  data: () => ({
      pageTitle: '',
      stepSize: 'sm',
      layout: '',
      showInfo: true,
      dataEntryComplete: false,
      skipSurvey: false,
      shortCode: '',
      finalModel: {},
      token: null,
      interview: { }
  }),
  
  created() {
      document.title = 'Welcome - Minnesota Department of Health COVID19 Interview'
      this.pageTitle = document.title
      this.token = this.$route.params.token
      this.validateToken()
  },

  computed: {
      symptoms() {
        return {
            covidSymptoms: this.finalModel.covidSymptoms,
            covidSymptomsStart: this.finalModel.covidSymptomsStart,
            covidLastTested: this.finalModel.covidLastTested,
        }
      },

      email() {
        return this.finalModel.emailAddress
      },
  },

  methods: {
    startSurvey(){
      this.showInfo=false
      this.switchTabs(-1,0)
    },
    showInfoPage(){
      this.showInfo=false
      this.dataEntryComplete=true
      this.skipSurvey = true
      this.switchTabs(-1,-1)
    },
    switchTabs(prevIdx, nextIdx) {
        var title = 'Welcome'
        switch (nextIdx) {
            case -1:
              title = 'Info'
              break;
            case 0:
              title = 'Tennessen Warning'
                break;
            case 1:
              title = 'Person Details'
                break;
            case 2:
              title = 'Exposures'
                break;
            case 3:
              title = 'Workspace'
                break;
            case 4:
              title = 'Schools'
                break;
            case 5:
              title = 'Essentials'
                break;
            case 6:
              title = 'COVIDaware App'
                break;
            default:
                title = 'Finished'
        }
        document.title = title + ' - COVID19 Interview'
        this.pageTitle = document.title
        document.getElementById('pgTitle').focus()       
    },

    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validate()
    },

    validateToken() {
      let payload = {
        id: this.token ? this.token : ''
      }

      this.interview =  { }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/token/validate`, payload)
        .then(response => {
          this.interview = response.data
          this.finalModel.medssEventId = this.interview.medssEventId
          this.finalModel.preferredLanguage = this.interview.preferredLanguage
          this.finalModel.token = this.interview.token
          this.setPreferredLanguage(this.interview.languageCode)
        })
    },

    setPreferredLanguage(lang) {
        this.$i18n.locale = lang;
        this.$root.$i18n.locale = lang;
    },

    mergePartialModels(model, isValid) {
      if(isValid){
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model)
        console.log(this.finalModel)
        if (this.finalModel.tennessenAcceptance === 'N') {
          let statusChanged = {
            medssEventId: this.finalModel.medssEventId,
            token: this.finalModel.token
          }

          axios.post(`${process.env.VUE_APP_API_BASE_URL}/statusChanged`, statusChanged)
          .then(response => {
          })
        }

      }
    },

    onComplete() {
        document.title = 'Thank you ' + ' - COVID19 Interview'
        this.pageTitle = document.title
        this.finalModel.code = this.randomString(8)
        this.shortCode = this.finalModel.code

        delete this.finalModel.languageOptions
        delete this.finalModel.tribeOptions
        delete this.finalModel.stateOptions
        delete this.finalModel.countyOptions
        delete this.finalModel.languagePrefOptions
        delete this.finalModel.en
        delete this.finalModel.so 
        delete this.finalModel.hmn 
        delete this.finalModel.es
        delete this.finalModel.dobMessages
        delete this.finalModel.covidSymptomsStartMessages
        delete this.finalModel.covidLastTestedMessages
        delete this.finalModel.recoveryDateMessages
        delete this.finalModel.srVaxDateMessages
        delete this.finalModel.travelStartMessages
        delete this.finalModel.travelEndMessages
        delete this.finalModel.employer
        delete this.finalModel.hcwEmployerObj
        delete this.finalModel.corrEmployerObj
        delete this.finalModel.schoolObj
        delete this.finalModel.defaultEmployer
        delete this.finalModel.k12Obj
        delete this.finalModel.ccObj
        delete this.finalModel.school
        delete this.finalModel.defaultItem
        delete this.finalModel.defaultContact

        this.finalModel.preferredLanguage = this.$root.$i18n.locale

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/registration`, this.finalModel)
        .then(response => {
        })
        
        this.dataEntryComplete = true
    },

    randomString(len) {
        let text = ''
        let chars = "abcdefghijklmnopqrstuvwxyz0123456789"
        for (let i = 0; i < len; i++ ) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return text.toUpperCase()
    },

    scrollTo() {
        let elem = document.getElementById("wizard")
        elem.scrollIntoView()
        window.scrollTo(0,0)
    },

     resizeThrottler() {
      var resizeTimeout;
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          this.sizeHandler();
          // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
      }
    },
    sizeHandler() {
      let w = window.innerWidth
      this.layout = ""
      if (w < 750) {
        this.stepSize = "xs"
        //this.layout = "vertical"
      } else if (w > 750 && w < 1000) {
        this.stepSize = "xs"
      } else {
        this.stepSize = "sm"
      }
    },
    fixTabOrder() {
      this.$nextTick(function () {
        var steps = document.querySelectorAll("div[role='tab']")
        steps.forEach(step => {
            step.setAttribute("tabindex", "-1")
        })

        var steps2 = document.querySelectorAll(".wizard-nav-pills>li>a");
         steps2.forEach(step => {
            step.setAttribute("tabindex", "-1")
        })
      })
    }
  },
  mounted() {

        if (localStorage.getItem('reloaded')) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem('reloaded');
    } else {
        // Set a flag so that we know not to reload the page twice.
        localStorage.setItem('reloaded', '1');
        location.reload();
    }

    window.addEventListener("resize", this.resizeThrottler, false);
    this.sizeHandler()
    this.fixTabOrder()
  },
  updated: function() {
      this.fixTabOrder()
  }
  
  
}
</script>

<style>
@media only screen and (max-width: 750px) {
  .vue-form-wizard .wizard-nav {
        display: none !important;
    }
    .vue-form-wizard .wizard-nav-pills {
        display: none !important;
    }
    .vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
        display: none !important;
    }

    .vue-form-wizard .wizard-btn {
        min-width: 120px !important;
    }
}

.vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon {
    color: white !important;
}

.vue-form-wizard .wizard-tab-content {
    min-height: 100px;
    padding: 30px 20px 10px;
    margin-bottom: 36px;
}

.wizard-title {
    display: none;
}

    
</style>